import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { Paging } from '../../../model/paging/paging';
import { BomComponent } from '../../../model/bom-component/bom-component';

@Injectable({
  providedIn: 'root'
})
export class BomComponentService_Mock {
  GETPaginatedBomComponents(paging: Paging): Observable<BomComponent> | any {
    const allData = this.getMockComponents();
    const start = (paging.pageIndex - 1) * paging.pageSize;
    const end = start + paging.pageSize;
    const pageData = allData.slice(start, end);

    return of({
      success: true,
      errorCode: 0,
      errorMessage: null,
      elapsed: 10,
      data: {
        count: allData.length,
        items: pageData
      }
    });
  }

  GETComponentById(componentId: string): Observable<BomComponent> | any {
    const component = this.getMockComponents().find((item) => item.code === componentId) ?? this.getMockComponents()[0];

    return of({
      success: true,
      errorCode: 0,
      errorMessage: null,
      elapsed: 8,
      data: component
    });
  }

  PUTBomComponentStatus(componentId: string, body: BomComponent) {
    return of({
      success: true,
      errorCode: 0,
      errorMessage: null,
      elapsed: 9,
      data: true
    });
  }

  DELETEBomComponent(componentId: string) {
    return of({
      success: true,
      errorCode: 0,
      errorMessage: null,
      elapsed: 7,
      data: true
    });
  }

  POSTBomComponent(body: BomComponent) {
    return of({
      success: true,
      errorCode: 0,
      errorMessage: null,
      elapsed: 9,
      data: true
    });
  }

  private getMockComponents() {
    return [
      {
        code: 'component-a',
        name: 'Component A',
        category: 'Category 1',
        description: 'First component description',
        active: true
      },
      {
        code: 'component-b',
        name: 'Component B',
        category: 'Category 2',
        description: 'Second component description',
        active: false
      },
      {
        code: 'coupler-x1',
        name: 'Coupler X1',
        category: 'RF',
        description: 'Directional coupler for indoor antenna branches.',
        active: true
      },
      {
        code: 'splitter-3w',
        name: 'Splitter 3-Way',
        category: 'Passive',
        description: 'Three-way splitter for medium-power distribution.',
        active: true
      },
      {
        code: 'cable-lszh-10m',
        name: 'LSZH Cable 10m',
        category: 'Cable',
        description: 'Low-smoke zero-halogen coaxial cable, 10 meters.',
        active: false
      }
    ];
  }
}
